// juno/about/index.ts
import top from "./top.jpg";
import t2iBefore from "./t2i-before.jpg";
import t2iAfter from "./t2i-after.jpg";
import i2iBefore from "./i2i-before.jpg";
import i2iAfter from "./i2i-after.jpg";
import sample01 from "./sample01.jpg";
import before01 from "./before01.jpg";
import after01 from "./after01.jpg";
import editSample from "./edit-sample.jpg";
import editBefore from "./edit-before.jpg";
import editAfter from "./edit-after.jpg";
import relightBefore from "./relight-before.jpg";
import relightAfter from "./relight-after.jpg";
import productBefore from "./product-before.jpg";
import productAfter from "./product-after.jpg";
import section21 from "./section2-1.jpg";
import section22 from "./section2-2.jpg";
import section23 from "./section2-3.jpg";

const JunoAbout = {
  top,
  t2iBefore,
  t2iAfter,
  i2iBefore,
  i2iAfter,
  sample01,
  before01,
  after01,
  editSample,
  editBefore,
  editAfter,
  relightBefore,
  relightAfter,
  productBefore,
  productAfter,
  section21,
  section22,
  section23,
};

export default JunoAbout;

// 個別エクスポート
export {
  top as junoAboutTop,
  t2iBefore as junoAboutT2iBefore,
  t2iAfter as junoAboutT2iAfter,
  i2iBefore as junoAboutI2iBefore,
  i2iAfter as junoAboutI2iAfter,
  sample01 as junoAboutSample01,
  before01 as junoAboutBefore01,
  after01 as junoAboutAfter01,
  editSample as junoAboutEditSample,
  editBefore as junoAboutEditBefore,
  editAfter as junoAboutEditAfter,
  relightBefore as junoAboutRelightBefore,
  relightAfter as junoAboutRelightAfter,
  productBefore as junoAboutProductBefore,
  productAfter as junoAboutProductAfter,
  section21 as junoAboutSection21,
  section22 as junoAboutSection22,
  section23 as junoAboutSection23,
};
